import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';

const CustomDatePicker = ({
    label,
    value,
    onChange,
    minDate,
    maxDate,
    ...props
}) => (
    <DatePicker
        label={label}
        value={value}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        renderInput={(params) => (
            <TextField
                {...params}
                size="small"
                sx={{
                    width: '126px',
                    fontSize: '14px',
                    fontWeight: 600,
                    borderRadius: '8px',
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        color: '#7A7A7A',
                        fontSize: '14px',
                        fontWeight: 600,
                        borderColor: '#F2F2F2',
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#7A7A7A',
                    },
                }}
            />
        )}
        {...props}
    />
);

export default CustomDatePicker;